/* Orthizen post-purchase offer logic. Config + variants come from a JSON script tag. */
(function(){
  /* Personalization: reads ?n=FirstName from the URL and, if present, fills the
     headline lead-in and the "reserved for" callout. Never touches innerHTML with
     the name - always textContent, so the query string can't inject markup.
     If the param is absent, the server-rendered fallback copy (already generic
     and non-broken) is left exactly as-is. */
  function applyPersonalization(){
    var name;
    try {
      name = new URLSearchParams(window.location.search).get('n');
    } catch(e){ return; }
    if(!name) return;

    var clean = name.trim();
    if(!clean) return;
    clean = clean.slice(0, 40);

    var lead = document.getElementById('ozppNameLead');
    if(lead) lead.textContent = clean + ', add insoles to your order and ';

    var reservedName = document.getElementById('ozppReservedName');
    if(reservedName) reservedName.textContent = clean;
  }

  function boot(){
    applyPersonalization();

    var cfgEl = document.getElementById('ozppConfig');
    if(!cfgEl) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch(e){ return; }

    var VARIANTS = cfg.variants || [];
    var sizeSel  = document.getElementById('ozppSize');
    var colorSel = document.getElementById('ozppColor');
    var accept   = document.getElementById('ozppAccept');
    var decline  = document.getElementById('ozppDecline');
    var errBox   = document.getElementById('ozppErr');
    var clock    = document.getElementById('ozppClock');
    var timerBox = document.getElementById('ozppTimer');
    var timerTxt = document.getElementById('ozppTimerText');

    function uniq(a){
      var seen = [];
      for(var i=0;i<a.length;i++){ if(seen.indexOf(a[i])===-1) seen.push(a[i]); }
      return seen;
    }

    function setOptions(sel, values){
      if(!sel) return;
      while(sel.firstChild){ sel.removeChild(sel.firstChild); }
      for(var i=0;i<values.length;i++){
        var o = document.createElement('option');
        o.value = values[i];
        o.textContent = values[i];
        sel.appendChild(o);
      }
    }

    function sizesList(){
      var out = [];
      for(var i=0;i<VARIANTS.length;i++){ out.push(VARIANTS[i].size); }
      return uniq(out);
    }

    function colorsForSize(size){
      var out = [];
      for(var i=0;i<VARIANTS.length;i++){
        if(VARIANTS[i].size === size) out.push(VARIANTS[i].color);
      }
      return uniq(out);
    }

    function fillColors(){
      if(!colorSel || !sizeSel) return;
      setOptions(colorSel, colorsForSize(sizeSel.value));
    }

    function currentVariantId(){
      if(!VARIANTS.length) return null;
      var size  = sizeSel ? sizeSel.value : null;
      var color = colorSel ? colorSel.value : null;
      for(var i=0;i<VARIANTS.length;i++){
        if(VARIANTS[i].size === size && VARIANTS[i].color === color) return VARIANTS[i].id;
      }
      return VARIANTS[0].id;
    }

    setOptions(sizeSel, sizesList());
    fillColors();
    if(sizeSel) sizeSel.addEventListener('change', fillColors);

    /* countdown - held price, honest wording, survives refresh */
    var endKey = 'ozppEnd_' + (cfg.step || 'x');
    var stored = sessionStorage.getItem(endKey);
    var end = stored ? parseInt(stored, 10) : (Date.now() + (cfg.seconds || 150) * 1000);
    if(!stored) sessionStorage.setItem(endKey, String(end));

    function tick(){
      var left = Math.max(0, Math.round((end - Date.now())/1000));
      var m = Math.floor(left/60), s = left % 60;
      if(clock) clock.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if(left <= 0){
        clearInterval(iv);
        if(timerBox) timerBox.className += ' ozpp__timer--out';
        if(timerTxt) timerTxt.textContent = 'This offer has expired';
        if(clock) clock.textContent = '';
        if(accept){ accept.disabled = true; accept.textContent = 'Offer expired'; }
      }
    }
    tick();
    var iv = setInterval(tick, 1000);

    function showErr(msg){
      if(!errBox) return;
      errBox.textContent = msg;
      errBox.style.display = 'block';
    }

    if(accept){
      accept.addEventListener('click', function(){
        var vid = currentVariantId();
        if(!vid){ showErr('Please choose a size and colour.'); return; }
        var original = accept.textContent;
        accept.disabled = true;
        accept.textContent = 'Preparing your checkout...';

        fetch('/cart/clear.js', { method:'POST', headers:{'Content-Type':'application/json'} })
          .then(function(){
            return fetch('/cart/add.js', {
              method:'POST',
              headers:{'Content-Type':'application/json'},
              body: JSON.stringify({ items: [{ id: vid, quantity: 2 }] })
            });
          })
          .then(function(r){
            if(!r.ok) throw new Error('add failed');
            window.location.href = '/discount/' + cfg.code + '?redirect=/checkout';
          })
          .catch(function(){
            accept.disabled = false;
            accept.textContent = original;
            showErr('We could not add that to your cart. Please try another size, or continue below.');
          });
      });
    }

    if(decline){
      decline.addEventListener('click', function(){
        window.location.href = cfg.declineUrl;
      });
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
